import { Component, Prop, Watch } from "vue-property-decorator";
import { ICardInformations } from "../../../config/Absences.config";
import { TypeCongeCompteurEnum } from "../../../dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum";
import { mapCompteur } from "../../../Helper/absencesHelper";
import { IProgress } from "../../../shared/components/circularProgress/circularProgress";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { VueBase } from "../../Controls/VueBase";

@Component
export default class CarteCongeComponent extends VueBase {
	@Prop({ type: Number, required: true })
	public readonly typeConge!: TypeCongeCompteurEnum;

	@Prop({ type: Date, required: true })
	public readonly exercice!: Date | undefined;

	@Prop({ type: Number, required: false })
	public readonly moisRaz!: number | undefined;

	public dataReady = false;
	public compteur: ICardInformations | null = null;
	public progressList: IProgress[] = [];
	public showTooltip = false;
    public anneeCongeText = "";

    // Exposer l'enum pour l'utiliser dans le template
    public TypeCongeCompteurEnum = TypeCongeCompteurEnum;

	@Watch("exercice")
	public changeExercice(): void {
    	if (this.exercice != null) {
    		this.dataReady = false;
    		this.fetchData();
    	}
	}

	public mounted(): void {
    	this.dataReady = false;
    	EventBus.$on(EventConstants.UPDATE_CONGES, this.fetchData);
	}

	/**
	 * Récupère les données du compteur d'absence
	 * @returns {void}
	 */
	public fetchData(): void {
    	ServicesFactoryInstance.CompteurAbsenceService.getStatuAbsenceByType(this.typeConge, this.exercice, (data) => {
            this.compteur = mapCompteur(data, this.typeConge);
            this.mapProgress();
    	}, () => {
    		this.dataReady = true;
    		NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération du status des absences.");
    	});
	}

	/**
    * Met à jour la liste de progression circulaire selon les compteurs.
    * @returns {void}
    */
	public mapProgress(): void {
    	this.progressList = [
    		{ value: this.compteur?.data.joursRestants ?? 0, color: this.compteur?.data.joursRestantsColor ?? "" },
    		{ value: this.compteur?.data.joursPoses ?? 0, color: this.compteur?.data.joursPosesColor ?? "" },
    		// Si joursPris est négatif ou null/undefined alors prend 0
    		{ value: Math.max(this.compteur?.data.joursPris ?? 0, 0), color: this.compteur?.data.joursPrisColor ?? "" }
    	];
    	this.dataReady = true;
	}

	/**
    * Formatte un nombre de jours pour l'affichage
    * @param {number} nbJours - Le nombre de jours à formater
    * @returns un nombre de jour adapté à l'affichage
    */
	public formatNumber(nbJours: number): string {
    	return nbJours.toString().replace(".", ",");
	}

	/**
    * Retourne le texte du tooltip selon le type de congé sélectionné.
    * Computed
    * @returns {string} - Le texte du tooltip
    */
	public get getTooltipText(): string {
    	if (!this.exercice) {
    		return "Aucune période trouvée";
    	}
    	const date = new Date(this.exercice);
    	let annee = date.getFullYear() ?? 0;

    	// recalculer les années des compteurs en prenant en compte le mois de réinitialisation
    	if (this.typeConge == TypeCongeCompteurEnum.NMoins1 || this.typeConge == TypeCongeCompteurEnum.N) {
    		const mois = date.getMonth() + 1;
    		if (mois <= (this.moisRaz ?? 0)) {
    			annee = annee - 1;
    		}
		}

		if (this.typeConge == TypeCongeCompteurEnum.NMoins1) {
			this.anneeCongeText = `${annee - 1}/${annee}`;
		} else if (this.typeConge == TypeCongeCompteurEnum.N) {
			this.anneeCongeText = `${annee}/${annee + 1}`;
		}

		return "Congés de l'année";
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/carteConge/carteConge.ts